import type { ActiveEditor } from "../../types";

export default function imageSetup(editor: ActiveEditor, imageUploadCallback: (event: Event, editor: ActiveEditor) => void) {

    const fileInput = createFileEl();
    const isImageElement = (node: HTMLElement) => node.nodeName.toLowerCase() === 'img'
    const getImage = () => {
        const node = editor.selection.getNode() as HTMLElement;
        return isImageElement(node) ? node as HTMLImageElement : null;
    }

    fileInput.addEventListener("change", (e: Event) => imageUploadCallback(e, editor))
    editor.ui.registry.addButton("image", {
        icon: "image",
        onAction: () => fileInput.click()
    });

    editor.ui.registry.addContextForm('link-form', {
        launch: {
            type: 'contextformbutton',
            text: 'link',
        },
        position: "node",
        predicate: isImageElement,
        initValue: () => {
            const image = getImage() as HTMLImageElement;
            const width = image.getAttribute("width") || image.width.toString();
            return width.replace(/[^0-9]/g, "")
        },
        commands: [
            {
                type: 'contextformbutton',
                tooltip: 'Link',
                text: "확인",
                primary: true,
                onAction: (formApi) => {
                    const newWidth = Number(formApi.getValue());
                    if (isNaN(newWidth) || newWidth <= 0) return;
                    const image = getImage() as HTMLImageElement;
                    const width = `${Math.ceil(newWidth)}px`

                    editor.dom.setAttribs(image, { width })
                    editor.selection.collapse()
                    formApi.hide();
                }
            },
        ]
    })
}

function createFileEl() {
    const fileInput = document.createElement("input");
    fileInput.style.display = "none";
    fileInput.accept = "image/*"
    fileInput.type = "file";
    document.body.appendChild(fileInput);
    return fileInput
}